export const EXCHANGE_RATE_USDBTC_LABEL = ' / BTC'
export const EXCHANGE_RATE_SATSUSD_LABEL = 'SATS / '

export const HR24 = '24H'
